<template>
  <div>{{ status }}</div>
</template>
<script>
import Vue from "vue";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {},
  data() {
    return {
      status: "init",
      checkInterval: 300
    };
  },
  methods: {
    loadHtmlFromUrl() {
      var url = window.location.href;
      var arr = url.split("/");

      this.$http.get(arr[0] + "//" + arr[2]).then(
        response => {
          let html = response.body;

          let withQuotes = false;
          let tagStart = html.indexOf("<meta property=build:number");
          if (tagStart === -1) {
            withQuotes = true;
            tagStart = html.indexOf('<meta property="build:number');
          }

          let tagEnd = html.indexOf(">", tagStart);

          let contentStart = html.indexOf("content=", tagStart);

          if (withQuotes === false) {
            this.checkBuildNumber(html.substring(contentStart + 8, tagEnd));

            return;
          }

          this.checkBuildNumber(html.substring(contentStart + 9, tagEnd - 1));
        },
        response => {}
      );
    },
    checkBuildNumber(buildNumberFromHttp) {
      let buildNumberFromDom = document.querySelector(
        'meta[property="build:number"]'
      ).content;

      if (buildNumberFromDom !== buildNumberFromHttp) {
        this.notifyVue(
          "Een nieuwe versie van de software is gedetecteerd. Vernieuw de pagina in de browser om de nieuwste versie van de software te laden.",
          "upgrade",
          "warning",
          this.checkInterval * 1000
        );
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {
    setTimeout(this.loadHtmlFromUrl, 1000);
    setInterval(this.loadHtmlFromUrl, this.checkInterval * 1000);
  }
};
</script>
<style lang="scss" scoped>
div {
  display: none;
}
</style>
